import { POST } from "../../APiHelper/API"

export const getSeasons = (data, onSuccess, onError) => {
    POST("/api/v1/leagues/seasons", data, onSuccess, onError)
}
export const getSeasonsForAdminAPICall = (data, onSuccess, onError) => {
    POST("/api/v1/leagues/all_seasons", data, onSuccess, onError)
}